import { makeStyles } from '@material-ui/core/styles';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import config from '../../../app/config';
import { color } from '../../../app/theme';
import { TWD } from '../../../app/utils';
import icFile from '../../../assets/images/svg/ic_file.svg';
import icFileAdd from '../../../assets/images/svg/ic_file_add.svg';
import icFileAddHover from '../../../assets/images/svg/ic_file_add_green.svg';
import icFileHover from '../../../assets/images/svg/ic_file_green.svg';
import DropdownButton from '../../shared/DropdownButton';
import PageTitle from '../PageTitle';

const useStyles = makeStyles(
  {
    root: {},
    totalWordCount: {
      fontSize: '13px',
      fontStyle: 'normal',
      fontWeight: '600',
      lineHeight: 'normal',
      color: color.$13,
      '& > span': {
        border: `1px solid ${color.$10}`,
        padding: '2px 6px',
        borderRadius: 8,
      },
      '& > a': {
        color: color.$2,
        textDecorationLine: 'underline',
      },
    },
    red: {
      color: color.$17,
    },
    fcsb: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },
    marginBottom16: {
      marginBottom: 16,
    },
  },
  {
    name: 'Header',
  },
);

const Header = ({ pathKey }) => {
  const classes = useStyles();
  const history = useHistory();
  const { t } = useTranslation();
  const { orgId, id } = useParams();
  const { datasetUsed } = useSelector(store => store.aiBot);
  const { displayName, nextResource } = useSelector(
    store => store.organization,
  );

  const quota = nextResource?.resources?.ai_knowledge?.quota || 0;

  const menuItems = [
    {
      icon: icFile,
      iconHover: icFileHover,
      text: t(`${pathKey}:web`),
      onClick: () => {
        history.push(`/${pathKey}/${orgId}/${id}/knowledge/addWeb`);
      },
    },
    {
      icon: icFileAdd,
      iconHover: icFileAddHover,
      text: t(`${pathKey}:file`),
      onClick: () => {
        history.push(`/${pathKey}/${orgId}/${id}/knowledge/addFile`);
      },
    },
  ];

  return (
    <div className={classes.root}>
      <PageTitle
        title={t(`${pathKey}:knowledge`)}
        tooltip={t(`${pathKey}:knowledgeTooltip`)}
      />
      <div className={classnames(classes.fcsb, classes.marginBottom16)}>
        <div
          className={classnames(classes.totalWordCount, {
            [classes.red]: datasetUsed > quota,
          })}
        >
          {t(`${pathKey}:basicSettingContainer.totalWordCount`)}
          <span>{`${TWD(datasetUsed, false).format()}/${TWD(
            quota,
            false,
          ).format()}`}</span>
          {t(`${pathKey}:basicSettingContainer.totalWordCount1`)}
          <a
            href="/"
            rel="noopener noreferrer"
            target="_blank"
            onClick={() => {
              window.open(
                `mailto:${config.ADDON_UNAVAIABLE_MAIL}?subject=${t(
                  `${pathKey}:embeddingsMaxWordsEmailSubject`,
                )}&body=${encodeURIComponent(
                  t(`${pathKey}:embeddingsMaxWordsEmailBody`, {
                    orgId,
                    displayName,
                  }),
                )}`,
              );
            }}
          >
            {t(`${pathKey}:basicSettingContainer.totalWordCount2`)}
          </a>
          ？）
        </div>
        <DropdownButton
          buttonText={t(`${pathKey}:addDataset`)}
          menuItems={menuItems}
        />
      </div>
    </div>
  );
};

export default Header;
